import { render, staticRenderFns } from "./Dispense.vue?vue&type=template&id=176c2f84&scoped=true"
import script from "./Dispense.vue?vue&type=script&lang=ts"
export * from "./Dispense.vue?vue&type=script&lang=ts"
import style0 from "./Dispense.vue?vue&type=style&index=0&id=176c2f84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176c2f84",
  null
  
)

export default component.exports